<template>
  <a-row>
    <a-col :span="labelCol">
      <div class="label-title" v-if="title">{{title}}</div>
    </a-col>
    <a-col :span="valueCol">
      <a-form-item v-bind="validate">
        <a-radio-group
            name="sex"
            v-model:value="inputValue"
            @change="onChange"
          >
            <a-radio v-for="(v,k) in options" :key="k" :value="v.value">{{v.label}}</a-radio>
          </a-radio-group>
        <span v-if="validate" class="must">*</span>
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  props: {
    value: {
      type: Number
    },

    title: {
      type: String,
      default: '标题'
    },

    labelCol: {
      type: Number,
      default: 4
    },

    valueCol: {
      type: Number,
      default: 16
    },

    validate: {
      type: Object,
      default: () => null
    },

    options: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    const inputValue = ref(props.value)

    watch(props, e => {
      inputValue.value = e.value
    })

    const onChange = e => {
      emit('update:value', e.target.value)
    }

    return {
      inputValue,
      onChange
    }
  }
})
</script>

<style lang="less" scoped>
  .must{
    position: absolute;
    top: 0;
    right: -10px;
    color: #f00;
    font-size: 18px;
    line-height: 32px;
  }

  .ant-radio-checked .ant-radio-inner{
    border-color: transparent !important;
  }
  .ant-radio-inner{
    background: #ccc2ba !important;
  }
  .ant-radio-inner::after{
    background: #998675 !important;
  }
</style>
